/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-12 11:20:00
 * @LastEditTime: 2022-01-12 14:39:13
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账 - 数币对账单 - 汇总数据订单列表
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/SZRMBList/components/SzRmbPayOrderSummaryDataOrderListModal.jsx
 */


import React, { useState, useRef } from 'react'
import { Button, Modal } from 'antd';
import TableHelper from '../../../../components/TableHelper';
import { fetchPlatformRecordSzRmbPayOrderSummaryDataOrderInfoPage } from '../../../../services/platformAccountingRecord';
import ModalScrollContainer from '../../../../components/ModalScrollContainer';
import { formatTime } from '../../../../utils';
import SzRmbPayOrderSummaryDataOrderDetail from './SzRmbPayOrderSummaryDataOrderDetailModal';




const SzRmbPayOrderSummaryDataOrderList = (props) => {
    const [visible, setVisible] = useState(false);
    const [id, setId] = useState(null);
    let SzRmbPayOrderSummaryDataOrderDetailRef = useRef()
    const open = (id) => {
        setId(id)
        setVisible(true)
    }
    const close = () => {
        setVisible(false)
    }
    props.getRef && props.getRef({ open });
    const columns = [
        { title: '银行流水号', dataIndex: 'bankSerialNumber',width: 240, },
        { title: '记账日期', dataIndex: 'bookkeepingDate',width: 140, render: formatTime},
        { title: '柜台代码', dataIndex: 'counterCode',width: 100, },
        { title: '创建时间', dataIndex: 'createTime',width: 140, render: formatTime},
        { title: '发卡行/通道', dataIndex: 'issuer',width: 130, },
        { title: '清算金额', dataIndex: 'liquidationAmount',width: 100, },
        { title: '商户订单号', dataIndex: 'merchantOrderNo',width: 240, },
        { title: '订单金额', dataIndex: 'orderAmount',width: 100, },
        { title: '订单号', dataIndex: 'orderNo',width: 240, },
        { title: '订单状态', dataIndex: 'orderStatus',width: 100, },
        { title: '支付卡种', dataIndex: 'paymentCardType',width: 140, },
        { title: '手续费', dataIndex: 'serviceCharge',width: 100, },
        { title: '汇总数据id', dataIndex: 'summaryDataId',width: 140},
        { title: '交易金额', dataIndex: 'tradeAmount',width: 100, },
        { title: '付款方户名', dataIndex: 'tradeCardName',width: 140, },
        { title: '付款方账号/客户号', dataIndex: 'tradeCardNumber',width: 200 },
        { title: '交易时间', dataIndex: 'tradeDateTime',width: 140, render: formatTime},
        { title: '交易类型', dataIndex: 'tradeType',width: 100, },
        { title: '操作', dataIndex: 'actions', width: 70, fixed: 'right', render: (text, record) => {
            return <a onClick={() => SzRmbPayOrderSummaryDataOrderDetailRef.open(record.id)}>详情</a>
        } }
    ]
    const parseRequestData = (data) => {
        data.summaryDataId = id
        return data
    }
    return (
        <Modal
            visible={visible}
            width={950}
            title="汇总数据订单明细数据"
            destroyOnClose
            footer={<Button onClick={close}>关闭</Button>}
            onCancel={close}
        >
            <ModalScrollContainer>
                {id && (
                    <TableHelper 
                        columns={columns} 
                        scroll={{x: 3000}}
                        parseRequestData={parseRequestData} 
                        request={fetchPlatformRecordSzRmbPayOrderSummaryDataOrderInfoPage}  
                    />
                )}

            </ModalScrollContainer>
            <SzRmbPayOrderSummaryDataOrderDetail getRef={ref => SzRmbPayOrderSummaryDataOrderDetailRef = ref} />
        </Modal>
    )
}

export default SzRmbPayOrderSummaryDataOrderList



// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/SZRMBList/components/SzRmbPayOrderSummaryDataOrderListModal.jsx